"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const log_client_1 = require("@video/log-client");
const video_client_core_1 = require("@video/video-client-core");
const mobx_1 = require("mobx");
const package_json_1 = tslib_1.__importDefault(require("../../package-json"));
const online_watcher_1 = require("../utils/online-watcher");
const ui_state_1 = tslib_1.__importDefault(require("../utils/ui-state"));
const utils_1 = require("./utils");
class PlayerUiState extends ui_state_1.default {
    constructor(basePlayer, options) {
        var _a, _b, _c;
        super();
        /**
         * Indicates whether the get sound element(s)  is/are visible.
         */
        this.viewGetSound = true;
        /**
         * Watches for mouse over on the qualitySelect modal
         */
        this.qualityMouseOver = false;
        this.multistreamPlayerPublicKey = null;
        (0, mobx_1.makeObservable)(this, {
            // observers
            viewGetSound: mobx_1.observable,
            qualityMouseOver: mobx_1.observable,
            // computed
            encoderMuted: mobx_1.computed,
            encoderNoVideo: mobx_1.computed,
            availableBitrates: mobx_1.computed,
        });
        this._options = options;
        this.player = basePlayer;
        this.multistreamPlayerPublicKey = (_a = options === null || options === void 0 ? void 0 : options.multistreamPlayerPublicKey) !== null && _a !== void 0 ? _a : null;
        if (this.player.logger != null) {
            this.logger = new log_client_1.LoggerCore("VDC-web")
                .extend(this.player.logger)
                .setMessageAggregate("chain", `Player:${PlayerUiState.displayName}`);
        }
        else {
            this.logger = new log_client_1.LoggerCore("VDC-web")
                .setLoggerMeta("client", "VDC")
                .setLoggerMeta("chain", "PlayerUiState")
                .setLoggerMeta("release", package_json_1.default.version)
                .setMessageAggregate("contextId", (_b = (0, video_client_core_1.contextId)()) !== null && _b !== void 0 ? _b : undefined)
                .setMessageAggregate("instanceId", (_c = (0, video_client_core_1.instanceId)()) !== null && _c !== void 0 ? _c : undefined);
        }
        // backwards compatibility
        this.player.on("consumerVideoEnabled", (val) => this.emit("encoderNoVideo", !val));
        this.player.on("consumerAudioEnabled", (val) => this.emit("encoderMuted", !val));
        this.addInnerDisposer(this.player);
        this.addInnerDisposer((0, online_watcher_1.onlineWatcher)(this.logger));
    }
    get availableQualities() {
        var _a;
        if (this.player.isImplements(video_client_core_1.player.Feature.BITRATE_SWITCHING)) {
            return (_a = this.player.availableQualities) !== null && _a !== void 0 ? _a : [];
        }
        return [];
    }
    get availableBitrates() {
        if (this.player.isImplements(video_client_core_1.player.Feature.BITRATE_SWITCHING) && this.player.availableQualities != null) {
            return (0, utils_1.availableBitrateHelper)(this.player.availableQualities);
        }
        return [];
    }
    get availablePlayers() {
        var _a;
        if (this.player.isImplements(video_client_core_1.player.Feature.PLAYER_SELECTOR)) {
            return (_a = this.player.availablePlayers) !== null && _a !== void 0 ? _a : [];
        }
        return [];
    }
    /**
     * @deprecated.
     */
    get currentPlayer() {
        return this.player;
    }
    /**
     * @deprecated Use playerUiState.player.consumerAudioEnabled
     */
    get encoderMuted() {
        return this.player.isImplements(video_client_core_1.player.Feature.CONSUMER) ? !this.player.consumerAudioEnabled : null;
    }
    /**
     * @deprecated Use playerUiState.player.consumerVideoEnabled
     */
    get encoderNoVideo() {
        return this.player.isImplements(video_client_core_1.player.Feature.CONSUMER) ? !this.player.consumerVideoEnabled : null;
    }
    get showToolbar() {
        const video = this.videoMouseOver;
        const quality = this.qualityMouseOver;
        return video || quality;
    }
}
PlayerUiState.displayName = "PlayerUiState";
exports.default = PlayerUiState;
//# sourceMappingURL=ui-state.js.map